import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { path } from 'ramda';

import Header from './Header';
import Footer from './Footer';
import Toast from './Toast';
import Routes from '../routes';
import Loader from './Loader';

const mapStore = (store) => ({
  loading: path(['layout', 'loading'], store),
  toast: path(['layout', 'toast'], store),
});

const propTypes = {
  loading: PropTypes.bool,
  toast: PropTypes.object,
};

const Root = ({ loading, toast }) => (
  <div id="reactroot">
    <Header />
    <Routes />
    <Footer />
    <Loader loading={loading} />
    <Toast {...toast} />
  </div>
);

Root.propTypes = propTypes;

export default withRouter(connect(mapStore)(Root));
